/**
 * グッズオプションAPI
 * 画像生成時のメニュー設定に基づいて、作成可能なグッズサプライヤーを取得
 */

// API ベースURLを設定（他のAPIサービスと同じ方式）
const API_BASE = import.meta.env.VITE_AISHA_API_BASE || 'http://localhost:7999/api';

interface GoodsOptionsResponse {
  allowedSuppliers: string[];  // ['suzuri', 'printful'] など
  menuName: string;
  imageId: string;
}

/**
 * 画像IDから作成可能なグッズオプションを取得
 * @param imageId - LibraryのfrontendID
 * @returns 作成可能なサプライヤーのリストとメニュー情報
 */
export async function fetchGoodsOptions(imageId: string): Promise<GoodsOptionsResponse> {
  try {
    const url = `${API_BASE}/timeline/${imageId}/goods-options/`;
    console.log('🚀 API URL:', url);
    console.log('🔗 完全なURL:', url);
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      console.error('❌ グッズオプション取得エラー - ステータス:', response.status);
      console.error('❌ レスポンスURL:', response.url);
      // エラーの場合はグッズ作成を非表示（空配列を返す）
      return {
        allowedSuppliers: [],
        menuName: '不明',
        imageId: imageId
      };
    }

    const data = await response.json();
    console.log('✅ グッズオプション取得成功:', data);
    console.log('✅ 返されたallowedSuppliers:', data.allowedSuppliers);
    return data;
  } catch (error) {
    console.error('❌ グッズオプション取得エラー（catch）:', error);
    console.error('❌ エラー詳細:', error);
    // エラーの場合はグッズ作成を非表示（空配列を返す）
    return {
      allowedSuppliers: [],
      menuName: '不明',
      imageId: imageId
    };
  }
}